import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { authClient } from "../../lib/auth-client";
import { Button, Card, Field, Input, PageTitle } from "../../components/ui";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (password.length < 12) {
      setError("パスワードは12文字以上にしてください。");
      return;
    }
    if (password !== confirm) {
      setError("確認用パスワードが一致しません。");
      return;
    }
    setLoading(true);
    try {
      const res = await authClient.resetPassword({ newPassword: password, token });
      if (res.error) {
        setError("リンクが無効か期限切れです。お手数ですが再度お試しください。");
        return;
      }
      setDone(true);
      // リセット完了時に旧セッションはサーバ側で無効化される（[19] §6.7）
      setTimeout(() => navigate("/login"), 1500);
    } catch {
      setError("再設定に失敗しました。");
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return (
      <div className="mx-auto max-w-md">
        <PageTitle title="パスワードの再設定" />
        <Card className="text-center">
          <p className="text-sm text-rose-500">リンクが正しくありません。</p>
          <div className="mt-4">
            <Link to="/forgot-password">
              <Button variant="ghost">再設定メールを送り直す</Button>
            </Link>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-md">
      <PageTitle title="新しいパスワードの設定" />
      <Card>
        {done ? (
          <p className="text-center text-sm font-bold text-emerald-600">
            パスワードを再設定しました。ログイン画面へ移動します…
          </p>
        ) : (
          <form className="space-y-4" onSubmit={onSubmit}>
            <Field label="新しいパスワード（12文字以上）">
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Field>
            <Field label="新しいパスワード（確認）">
              <Input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </Field>
            {error && <p className="text-sm font-bold text-rose-500">{error}</p>}
            <Button type="submit" className="w-full" disabled={loading}>
              再設定する
            </Button>
          </form>
        )}
      </Card>
    </div>
  );
}
